CompanyListController.$inject =    ['$scope','companyService'];
function CompanyListController     ($scope, companyService){
    $scope.companies = [];

    let promises = [];

    promises.push(companyService.find({}));

    Promise.all(promises)
    .then(result => {
        $scope.companies = result[0];
    })
}

// Edit controller
CompanyEditController.$inject =    ['$scope', '$routeParams','companyService'];
function CompanyEditController     ($scope, $routeParams, companyService){
    $scope.company = {};

    let company_id = $routeParams.id;
    let promises = [];

    promises.push(companyService.get(company_id));

    Promise.all(promises)
    .then(result => {
        $scope.company = result[0];
    })

    $scope.remove = companyService.remove
    $scope.update = companyService.update
}

// New controller
CompanyNewController.$inject =    ['$scope','companyService'];
function CompanyNewController     ($scope, companyService){
    $scope.company = {};

    let promises = [];

    // Promise.all(promises)
    // .then(result => {
    // })

    $scope.add = companyService.add;
}

app.controller('CompanyEditController', CompanyEditController)
app.controller('CompanyNewController',  CompanyNewController)
app.controller('CompanyListController', CompanyListController)
